import {SlimSelectElement} from "js/slim-select/slim-select"
import {validateQuery} from "js/utils"

const items = document.querySelectorAll<HTMLAnchorElement>(".js-service-setter")

items.forEach((item) => {
  const href = item.getAttribute("href")
  const value = item.getAttribute("data-service")

  const selector = `${href} .f-single-select__select`

  if (!validateQuery(selector)) return

  const select = document.querySelector<SlimSelectElement>(selector)

  if (!href || !value || !select) return

  item.addEventListener("click", () => {
    if (select.slim) {
      select.slim.setSelected(value)
    } else {
      select.value = value
    }
  })
})
